import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef, isValidElement } from "react";
import { ThemeProvider } from "@m/alchemy-theme";
import * as Styled from "./AppBar.styled";
export const AppBar = forwardRef((props, ref) => {
    const { backgroundColor, backgroundImage, children, colorScheme, bottomBorderColor, priority, ...otherProps } = props;
    return (_jsx(ThemeProvider, { colorScheme: colorScheme, children: _jsx(Styled.AppBar, { "data-testid": "AppBar", ref: ref, colorScheme: colorScheme, priority: priority, backgroundColor: backgroundColor, backgroundImage: backgroundImage, bottomBorderColor: bottomBorderColor, ...otherProps, children: _jsx(Styled.AppBarContent, { priority: priority, children: React.Children.map(children, (child) => {
                    if (!isValidElement(child)) {
                        return null;
                    }
                    return React.cloneElement(child, {
                        priority
                    });
                }) }) }) }));
});
AppBar.defaultProps = {
    priority: "primary",
    colorScheme: "alchemyDark"
};
AppBar.displayName = "AppBar";
